const LogTemplates = () => import("Modules/configuration/log_templates/views/LogTemplates");
const LogTemplatesForm = () => import("Modules/configuration/log_templates/views/LogTemplatesForm");

export default {
    children: [
        {
            path: "log_templates",
            name: "log_templates",
            component: LogTemplates,
            meta: {
                requiresAuth: true,
                title: "lang.log_templates",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["log_templates.read"],
            },
        },
        {
            path: "log_template/:id?",
            name: "log_template",
            component: LogTemplatesForm,
            meta: {
                requiresAuth: true,
                title: "lang.log_templates",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["log_templates.read"],
            },
        },
    ],
};
